import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { ComponentProps } from '../utils/types';
import {
  StyledListItem,
  StyledListItemAction,
  StyledListItemDescription,
  StyledListItemIcon,
  StyledListItemTextContainer,
  StyledListItemTitle
} from './styles';
import {
  isAnchor,
  isButton,
  ListItemProps as ListItemPropsInterface
} from './types';

export const ListItem = React.forwardRef<HTMLElement, ListItemPropsInterface>(
  (
    { title, description, action, icon, loading = false, children, ...props },
    ref
  ) => {
    let wrapperTag: 'li' | 'a' | 'button' = 'li';
    let typedRef:
      | React.ForwardedRef<HTMLLIElement>
      | React.ForwardedRef<HTMLAnchorElement>
      | React.ForwardedRef<HTMLButtonElement>;
    if (isAnchor(props)) {
      typedRef = ref as React.ForwardedRef<HTMLAnchorElement>;
      wrapperTag = 'a';
    } else if (isButton(props) && !action) {
      typedRef = ref as React.ForwardedRef<HTMLButtonElement>;
      wrapperTag = 'button';
    } else {
      typedRef = ref as React.ForwardedRef<HTMLLIElement>;
    }
    return (
      <StyledListItem
        role="listitem"
        as={wrapperTag}
        isLoading={loading}
        ref={typedRef}
        {...props}
      >
        {icon && (
          <StyledListItemIcon>
            {loading ? <Skeleton width={32} height={32} /> : icon}
          </StyledListItemIcon>
        )}
        <StyledListItemTextContainer>
          {children}
          {title && (
            <StyledListItemTitle>
              {loading ? <Skeleton width={100} height={16} /> : title}
            </StyledListItemTitle>
          )}
          {description && (
            <StyledListItemDescription>
              {loading ? <Skeleton width={250} height={18} /> : description}
            </StyledListItemDescription>
          )}
        </StyledListItemTextContainer>
        {action && !loading && (
          <StyledListItemAction>{action}</StyledListItemAction>
        )}
      </StyledListItem>
    );
  }
);

export type ListItemProps = ComponentProps<typeof ListItem>;
export default ListItem;
